import ServiceChoosen from './service-choosen.vue'
export default ServiceChoosen 